(function () {
  function initTestimonialReadMore(section) {
    if (section.dataset.readMoreInitialized === "true") return;

    var button = section.querySelector("[data-read-more]");
    var hiddenItems = section.querySelectorAll(
      ".el-testimonial__mobile-item.is-hidden",
    );
    var readMoreLabel = "Read More Reviews";
    var readLessLabel = "Read Less Reviews";

    if (!button || hiddenItems.length === 0) return;

    section.dataset.readMoreInitialized = "true";

    button.addEventListener("click", function (event) {
      event.preventDefault();

      var isExpanded = button.getAttribute("aria-expanded") === "true";

      hiddenItems.forEach(function (item) {
        item.classList.toggle("is-hidden", isExpanded);
      });

      button.setAttribute("aria-expanded", String(!isExpanded));
      button.textContent = isExpanded ? readMoreLabel : readLessLabel;
    });
  }

  function init() {
    document
      .querySelectorAll(".el-testimonial-section")
      .forEach(initTestimonialReadMore);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
